import React, { Component, Fragment } from "react";
import "./webResponsiveActivity.css";
import Activity from "../quizViewer/activitiesUi/activity/model/Activity";
import SoundControlsUI from "../quizViewer/activitiesUi/activity/activityComponent/SoundControlsUI";
import CenterElement from "../quizViewer/activitiesUi/activity/activityComponent/CenterElement";
import ReadTextUI from "../quizViewer/activitiesUi/activity/activityComponent/ReadTextUI";
import MCQActivity from "../quizViewer/activitiesUi/mcq/ui/MCQActivity";
import DragWordToImgActivityUI from "../quizViewer/activitiesUi/ddTxtImg/ui/DragWordTiImgActivityUI";
import SortStoryActivityUI from "../quizViewer/activitiesUi/ddSortStory/ui/SortStoryActivityUI";
import DragDropParagraphActivityUI from "../quizViewer/activitiesUi/ddp/ui/DragDropParagraphActivityUI";
import WordOnImgActvityUI from "../quizViewer/activitiesUi/wordOnImg/ui/WordOnImgActvityUI";
import CompareActivityUI from "../quizViewer/activitiesUi/compare/ui/CompareActvityUI";
import ClassificationActivityUI from "../quizViewer/activitiesUi/classification/ui/ClassificationActivityUI";
import ConnectActivityUI from "../quizViewer/activitiesUi/connect/ui/ConnectActivityUI";
import WriteMissingWordsActivityUI from "../quizViewer/activitiesUi/writeMissingWords/ui/WriteMissingWordsActivityUI";
import { Dialog } from "primereact/dialog";
import { act } from "@testing-library/react";
import { Sidebar } from "primereact/sidebar";
import { Fieldset } from "primereact/fieldset";
import { SelectButton } from "primereact/selectbutton";
import helpIcon from "../res/imgs/help.png";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
} from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faCheckSquare,
  faCoffee,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "primereact/button";
import AppFooter from "../quizViewer/activitiesUi/activity/activityComponent/AppFooter";
import { useRef } from "react";
import { useEffect } from "react";
import TFACtivityModel from "../quizViewer/activitiesUi/mcq/model/TFACtivityModel";
library.add(fab, faCheckSquare, faCoffee, faLightbulb);

class webResponsiveActivity extends Component {
  constructor() {
    super();

    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.count = this.count.bind(this);
    this.state = {
      time: {},
      seconds: 1,
      displayBasic: false,
      displayBasic2: false,
      displayModal: false,
      displayMaximizable: false,
      displayPosition: false,
      displayResponsive: false,
      position: "center",
    };
    this.onClick = this.onClick.bind(this);
    this.onHide = this.onHide.bind(this);
  }
  onClick(name, position) {
    let state = {
      [`${name}`]: true,
    };

    if (position) {
      state = {
        ...state,
        position,
      };
    }
    this.loadReminderCard();
    this.setState(state);
  }

  onHide(name) {
    this.setState({
      [`${name}`]: false,
    });
  }

  renderFooter(name) {
    return (
      <div>
        <Button
          label="No"
          icon="pi pi-times"
          onClick={() => this.onHide(name)}
          className="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          onClick={() => this.onHide(name)}
          autoFocus
        />
      </div>
    );
  }
  startTimer() {
    if (this.timer == 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.count, 1000);
    }
  }
  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }
  count() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds + 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds == 0) {
      clearInterval(this.timer);
    }
  }
  componentDidUpdate = () => {
    if (this.ref != null) window.x(this.ref);
  };
  state = {
    displayDialog: false,
    windowH: 0,
    displayErrorDialog: false,
  };

  componentDidUpdate = () => {
    let ansExplaination = document.getElementById("ansExplaination");
    // ansExplaination.style.height = (ansExplaination.offsetHeight + 50) + "px"
    if (ansExplaination)
      ansExplaination.scrollIntoView({ behavior: "smooth", block: "end" });
  };

  componentDidMount() {
    window.activityUI = this;

    let h = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || window.parent.innerHeight
    );
    this.setState({ windowH: h });
    this.startTimer();
  }

  componentWillReceiveProps = () => {};

  render = () => {
    let { app, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    let { callbackData } = quizViwerModel;
    let activity = new Activity();
    if (quizViwerModel.currentActivity != -1) {
      activity = quizViwerModel.activityArr[quizViwerModel.currentActivity];
      // this.fillReminderCard(activity)
    }

    let { selectedStyle } = quizViwerModel;
    let { projectPlugin } = quizViwerModel;
    const reactionOptions = [
      { icon: "pi pi-thumbs-up", value: "left" },
      { icon: "pi pi-thumbs-down", value: "Right" },
    ];

    this.items = [
      {
        label: "بطاقة تذكيرية",
        icon: "pi pi-book",
        command: () => {
          this.setState({ displayDialog: true });
        },
      },
      {
        label: "ملف pdf",
        icon: "pi pi-file-pdf",
        command: () => {
          // this.toast.show({ severity: 'success', summary: 'Update', detail: 'Data Updated' });
        },
      },
      {
        label: "فيديو الشرح",
        icon: "pi pi-video",
        command: () => {
          // this.toast.show({ severity: 'error', summary: 'Delete', detail: 'Data Deleted' });
          window.history.back();
        },
      },
    ];
    let content = activity.reminderCard;

    return (
      <Fragment>
        {/* <AppHeader quizViwerModel={quizViwerModel} activity={activity} /> */}
        <div id="activityBackground">
          <p className="countDown">
            {this.state.time.m >= 10
              ? this.state.time.m
              : `0${this.state.time.m}`}
            :
            {this.state.time.s >= 10
              ? this.state.time.s
              : `0${this.state.time.s}`}
          </p>
          <p>وحده 1 - الدرس: موقع مصر واهميته </p>
        </div>
        <div
          id="activityMainContainer"
          style={{
            direction: quizViwerModel.callbackData.dir,
          }}
        >
          <div
            className={` ${
              quizViwerModel.reviewMode ? "container reviewMode" : "container"
            }`}
            style={{
              display: quizViwerModel.reviewMode ? "flex" : "grid",
            }}
          >
            <SoundControlsUI activity={activity} quizViewer={quizViewer} />
            <ReadTextUI activity={activity} quizViewer={quizViewer} />

            <div className="countContainer">
              <p className="countDown">
                {this.state.time.m}:{this.state.time.s}
              </p>
              <i
                className="pi pi-clock "
                style={{ width: "16.7px", height: "16.7px" }}
              ></i>
            </div>
            <Dialog
              className="dialog"
              visible={this.state.displayModal}
              style={{ width: "50vw", overflow: "hidden", zIndex: "2000000" }}
              breakpoints={{ "960px": "75vw", "640px": "100vw" }}
              footer={this.renderFooter("displayModal")}
              onHide={() => this.onHide("displayModal")}
            >
              <p
                dangerouslySetInnerHTML={{ __html: content }}
                style={{ direction: "rtl" }}
              ></p>
            </Dialog>

            {quizViwerModel.activityArr.map((activity, index) => {
              return (
                <Fragment key={index}>
                  {quizViwerModel.currentActivity == activity.activityIndex
                    ? this.getActivity(activity, index)
                    : ""}
                </Fragment>
              );
            })}
            <div
              id="ansExplaination"
              hidden={!quizViwerModel.reviewMode}
              // style={{ marginTop: "4rem" }}
            >
              <CenterElement
                // content={window.toAbsAllImgSrcs(activity.answerExplanation).replaceAll(/^<br>/g, '')}
                content={window.toAbsAllImgSrcs(activity.answerExplanation)}
                style={{}}
                textAlign="center"
              />
            </div>
          </div>

          <div
            className={
              quizViwerModel.callbackData.isExam == "false"
                ? "col-5 col-align-center margin flex progress-items"
                : "col-6 col-align-center  flex progress-items"
            }
            style={{
              textAlign: "right",
              marginBottom: "20px",
              paddingRight:
                quizViwerModel.callbackData.isExam == "false"
                  ? "20px"
                  : "0px 20px",
              backgroundColor: " #fcfcfc",
            }}
          >
            <div style={{ display: "flex" }}>
              <span
                style={{
                  fontFamily: "sstArabic!important",
                  fontWeight: "600",
                  color: "#58C4A4",
                }}
              >
                {" "}
                {this.toArabicDigits(quizViwerModel.currentActivity + 1)}{" "}
              </span>{" "}
              /{" "}
              <span
                style={{
                  fontFamily: "sstArabic!important",
                  fontWeight: "600",
                }}
              >
                {" "}
                {this.toArabicDigits(quizViwerModel.activityArr.length)}
              </span>
              {/* <div style={{ position: "absolute", left: "0", top: "0", height: "100%", borderRadius: "5px", backgroundColor: "#94ab8d", width: this.getCurrentQProgress() + "%" }}></div> */}
            </div>
            <div
              className="progressBar"
              style={{
                position: "relative",
                height: "10px",
                borderRadius: "5px",
                width: "90%",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  right: "0",
                  top: "0",
                  height: "100%",
                  width:
                    ((quizViwerModel.currentActivity + 1) /
                      quizViwerModel.activityArr.length) *
                      100 +
                    "%",
                  background: "#58C4A4",
                  borderRadius: "5px",
                }}
              ></div>
              <span
                className="help-span"
                onClick={() => this.onClick("displayModal")}
              >
                <img src={helpIcon} style={{ width: "25px" }} />
                مساعدة
              </span>
            </div>
          </div>

          {/* (quizViwerModel.reviewMode ?
                         <> */}
        </div>
        <AppFooter
          quizViewer={quizViewer}
          quizViwerModel={quizViwerModel}
          activity={activity}
        />

        <Sidebar
          visible={this.state.displayDialog}
          position="bottom"
          onHide={this.closeSideBar}
        >
          <div
            style={{ direction: "rtl", textAlign: "right" }}
            dangerouslySetInnerHTML={{
              __html: window.toAbsAllImgSrcs(activity.reminderCard),
            }}
          ></div>
          <AppFooter
            quizViewer={quizViewer}
            quizViwerModel={quizViwerModel}
            activity={activity}
          />
        </Sidebar>

        <Dialog
          dismissableMask
          position="center"
          direction="rtl"
          visible={this.state.displayErrorDialog}
          // maximizable={true}
          header="الإجابة خطأ"
          style={{ width: "90%", dir: "rtl" }}
          onHide={() => this.setState({ displayErrorDialog: false })}
        >
          <div
            style={{ direction: "rtl", textAlign: "center", padding: "1rem" }}
          >
            <Button
              className="btn-shape btnColor"
              label="إعادة المحاولة"
              onClick={(e) => {
                this.setState({ displayErrorDialog: false });
              }}
            ></Button>
          </div>
        </Dialog>
      </Fragment>
    );
  };

  closeSideBar = () => {
    this.setState({ displayDialog: false });

    if (window.parent.Android && window.parent.Android !== null) {
      window.parent.Android.enableBrowserBack();
    }
  };

  speedDialButtonTemplete = (el) => {
    return (
      <img
        src={helpIcon}
        style={{ width: "4rem" }}
        onClick={() => this.speedDialClick(el)}
      />
    );
  };

  speedDialClick = (el) => {
    this.loadReminderCard((activity) => {
      if (activity && activity.videoLinks != "") el.onClick();
      else this.setState({ displayDialog: true });
    });
  };
  handleReactionChange = (e) => {
    let { app, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    let { callbackData } = quizViwerModel;
    let activity = new Activity();
    if (quizViwerModel.currentActivity != -1) {
      activity = quizViwerModel.activityArr[quizViwerModel.currentActivity];
    }
    activity.reaction = e.value;
    quizViewer.setState({});
  };
  justifyTemplate = (option) => {
    return <i className={option.icon}></i>;
  };
  getCurrentQProgress = () => {
    let { quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;

    return (
      (quizViwerModel.currentActivity / quizViwerModel.activityArr.length) * 100
    );
  };

  loadReminderCard = (callback) => {
    let { quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let activity = new Activity();
    if (quizViwerModel.currentActivity != -1) {
      activity = quizViwerModel.activityArr[quizViwerModel.currentActivity];

      activity.getLOList((res) => {
        console.log(res.data);
        activity.reminderCard = "";
        if (res.data.code == 200) {
          activity.videoLinks =
            res.data["video-links"].length > 0
              ? res.data["video-links"][0]
              : "";

          res.data.data.map((item) => {
            if (activity.reminderCard == "")
              activity.reminderCard = item.content;
            else activity.reminderCard += "<br/>" + item.content;
          });
          quizViewer.setState({});
          // this.setState({ displayDialog: true })
        }

        activity.useReminderCard = true;

        callback(activity);
      });
    }

    // if (window.parent.Android !== null) {
    //     window.parent.Android.disableBrowserBack()
    // }
  };

  getActivity = (activity, index) => {
    let { app, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;

    if (activity.activityType == activity.TF_ACTIVITY_TYPE) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
            width: "100%",
            margin: "auto 0",
            position: "relative",
          }}
        >
          <MCQActivity
            activity={activity}
            quizViewer={quizViewer}
            reviewMode={quizViwerModel.reviewMode}
          />
        </div>
      );
    } else if (activity.activityType == activity.DRAG_WORD_TO_IMG) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
          }}
        >
          <DragWordToImgActivityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
            className="drag-drop-item"
          />
        </div>
      );
    } else if (activity.activityType == activity.SORT_STORY) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
          }}
        >
          <SortStoryActivityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
          />
        </div>
      );
    } else if (activity.activityType == activity.DRAG_DROP_PARGRAPH) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
          }}
        >
          <DragDropParagraphActivityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
          />
        </div>
      );
    } else if (activity.activityType == activity.WORD_ON_IMG) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
            width: "100%",
            height: "23vh",
            // margin: "140px 0",
          }}
        >
          <WordOnImgActvityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
          />
        </div>
      );
    } else if (activity.activityType == activity.COMPARE) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
          }}
        >
          <CompareActivityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
          />
        </div>
      );
    } else if (activity.activityType == activity.CLASSIFICATION) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
          }}
        >
          <ClassificationActivityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
          />
        </div>
      );
    } else if (activity.activityType == activity.CONNECT) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
          }}
        >
          <ConnectActivityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
          />
        </div>
      );
    } else if (activity.activityType == activity.WRITE_MISSING_WORDS) {
      return (
        <div
          style={{
            display:
              index == quizViwerModel.currentActivity ? "inline" : "none",
          }}
        >
          <WriteMissingWordsActivityUI
            activity={activity}
            quizViewer={this.props.quizViewer}
          />
        </div>
      );
    }
  };

  handlebackToResultpage = () => {
    let { app, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    quizViwerModel.showResultPage = true;
    quizViewer.setState({});

    this.props.history.push("/result_page_mobile/false");
    // window.history.back();
  };
  onDialogClose = (activity) => {
    this.setState({ displayDialog: false });
    activity.resetActivity();
  };

  toArabicDigits = (num) => {
    var id = ["۰", "۱", "۲", "۳", "٤", "٥", "٦", "۷", "۸", "۹"];
    return num.toString().replace(/[0-9]/g, function (w) {
      return id[+w];
    });
  };
}

export default withRouter(webResponsiveActivity);
